// Port of api/fuel/app/classes/filter/template/users.php
export default {
	fill: function(values) {
		var defaults = {
			text: '',
			sort: 'firstname'
		}
		if (!values) return defaults
		var keys = Object.keys(defaults)
		for (var i = 0; i < keys.length; i++) {
			if (values[keys[i]] === undefined) values[keys[i]] = defaults[keys[i]]
		}
		return values
	},
	session: function() { return false }
}
